import { useState, useEffect, useCallback } from "react";
import { loadImages, saveImage, resetImages } from "@/hooks/imageStorage";

export interface HeroImages {
  heroBg: string;
  card1: string;
  card2: string;
  card3: string;
}

const defaults: HeroImages = {
  heroBg:
    "https://storage.helloreaddy.io/project_files/1655f95b-cd6b-479d-8503-b76e04453858/bdbe5038-8041-470e-85f6-99863ad72f7c_compressed_original-71391246-8F86-4C9C-9F89-362054205D29.webp",
  card1:
    "https://storage.helloreaddy.io/project_files/1655f95b-cd6b-479d-8503-b76e04453858/dbb1d92f-fd26-4c96-865e-b86ca0d2d41a_compressed_original-FBDD6CD2-AC58-486B-850C-10090F693A9F.webp",
  card2:
    "https://storage.readdy-site.link/project_files/1655f95b-cd6b-479d-8503-b76e04453858/7416460e-471f-4323-86b9-819a1827b58b_compressed_processed-2936C1AE-6785-4445-B102-C680173C007B.webp",
  card3:
    "https://storage.helloreaddy.io/project_files/1655f95b-cd6b-479d-8503-b76e04453858/f358bff0-82e0-4aee-975a-dfe0274bac96_compressed_IMG_3546.webp",
};

export function useEditableImages() {
  const [images, setImages] = useState<HeroImages>(defaults);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      const stored = await loadImages();
      setImages({ ...defaults, ...stored });
      setLoaded(true);
    })();
    resetImages();
  }, []);

  const updateImage = useCallback(
    async (key: keyof HeroImages, url: string) => {
      setImages((prev) => ({ ...prev, [key]: url }));
      await saveImage(key, url);
    },
    []
  );

  const resetAll = useCallback(async () => {
    setImages(defaults);
    await resetImages();
  }, []);

  const hasCustom = useCallback(() => {
    return (Object.keys(defaults) as (keyof HeroImages)[]).some(
      (k) => images[k] !== defaults[k]
    );
  }, [images]);

  return { images, updateImage, resetAll, hasCustom, loaded };
}